export const style = {
  boxContainer: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    },
    boxRow: {
      sx: {
        color: 'text.secondary',
        display: 'flex',
        alignItems: 'center',
      },
    },
    Typography: {
      variant: 'caption',
      text: 'text.secondary',
    },
  },
} as const;
